import { Link, useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import Layout from '../../components/global/layout';
import ApiClient from '../../methods/api/apiClient';
import shared from './shared';
import loader from '../../methods/loader';
import methodModel from '../../methods/methods';
import { CgArrowLeft } from "react-icons/cg";
import { FiPlus } from 'react-icons/fi';

import { BsArrowBarLeft } from 'react-icons/bs';
import PhoneInput from 'react-phone-input-2';
import { LiaEdit } from 'react-icons/lia';
import { useSelector } from 'react-redux';
import { FaChevronLeft, FaEdit } from 'react-icons/fa';
import { RiFileList3Line } from 'react-icons/ri';
import { FaListCheck } from 'react-icons/fa6';

function ViewStaff() {
  const user = useSelector(state => state.user);
  const [data, setData] = useState();
  const history = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    getDetail();
  }, []);

  const getDetail = () => {
    loader(true);
    ApiClient.get(shared.detailApi, { id }).then((res) => {
      loader(false);
      if (res.success) {
        const { data } = res;
        data.permissions = data.permissions || []; // Ensure permissions is an array
        setData(data);
      }
    });
  };

  const openImage = (image) => {
    if (image) window.open(methodModel.noImg(image), '_blank');
    else return;
  };

  return (
    <Layout>
      <div className="wrapper_section">

        <div className='flex gap-3 justify-between flex-wrap mb-8'>
          <div className="flex gap-3">
            <Tooltip placement="top" title="Back">
              <Link
                onClick={() => history(-1)}
                className="min-w-[30px] w-[30px] h-[30px] rounded-full bg-[#CC9900] text-white flex items-center justify-center hover:opacity-80"
              >
                <FaChevronLeft />
              </Link>
            </Tooltip>
            <div className=''>
              <h3 className="text-lg lg:text-2xl font-semibold text-[#221E10]">
                {shared.addTitle} Details
              </h3>
              <p className='text-sm text-[#2D2D2D]'></p>
            </div>
          </div>



          {methodModel.hasPermission(user, shared.permissionKey, 'edit') && <Tooltip placement="top" title="Edit">
            <Link to={`/${shared.route}/edit/${id}`} className=" flex items-center gap-1 hover:opacity-80 ml-auto" >
              <span className='cursor-pointer rounded-full w-8 h-8 flex items-center justify-center text-lg hover:opacity-80 bg-[#F2F2F2] text-[#797979]'><FaEdit className='' /></span>
              <p className='text-[#797979] text-md'>Edit</p>
            </Link>
          </Tooltip>}


        </div>


        <div className="grid grid-cols-1 gap-6">
          <div className="bg-white p-5 rounded-[12px] shadow-[0px_3px_14px_-8px_#888888] border">
            <div className='mb-5'>
              <div className='flex gap-2'>
                <RiFileList3Line className="text-[#CC9900] text-xl relative top-[1px]" />
                <h4 className='text-[#2D2D2D] font-semibold'>Basic Information </h4>
              </div>
              <p className='text-sm text-[#717182]'></p>
            </div>
            <div className="grid grid-cols-12 gap-5">
              {/* Basic Information Fields */}
              <div className="col-span-12 sm:col-span-6">
                <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">First Name:</label>
                <p className="relative bg-[#F7F7F7] text-[#7B7B7B] w-full rounded-lg min-h-10 flex items-center focus:outline focus:outline-[1px] focus:outline-[#e5e7eb] focus:ring-0 py-2 px-3 capitalize">
                  {data && data.firstName}
                </p>
              </div>
              <div className="col-span-12 sm:col-span-6">
                <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">Last Name:</label>
                <p className="relative bg-[#F7F7F7] text-[#7B7B7B] w-full rounded-lg min-h-10 flex items-center focus:outline focus:outline-[1px] focus:outline-[#e5e7eb] focus:ring-0 py-2 px-3 capitalize">
                  {data && data.lastName}
                </p>
              </div>
              <div className="col-span-12 sm:col-span-6">
                <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">Email:</label>
                <p className="text-[13px] text-black  bg-[#f5f5f5] min-h-[45px] rounded-md items-center  px-3 py-2 leading-[18px] break-words flex items-center">
                  {data && data.email}
                </p>
              </div>
              <div className="col-span-12 sm:col-span-6">
                <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">Mobile Number:</label>
                <p className="relative bg-[#F7F7F7] text-[#7B7B7B] w-full rounded-lg min-h-10 flex items-center focus:outline focus:outline-[1px] focus:outline-[#e5e7eb] focus:ring-0 py-2 px-3">
                  {data?.mobileNo ?
                    <div className="your-custom-class">
                      <PhoneInput
                        value={data?.mobileNo}
                        disabled
                      />
                    </div>
                    : '--'}
                </p>
              </div>
              {data?.image && (
                <div className="col-span-12">
                  <label className="text-[14px] text-[#0000009c] tracking-wider mb-1">Image:</label>
                  <div className="flex flex-wrap gap-3 ">
                    <Tooltip position="top" title="Click to open">
                      <img
                        src={methodModel.noImg(data?.image)}
                        className={`bg-white thumbnail !w-[100px] !h-[100px] rounded-lg shadow-lg border-[2px] border-white object-contain ${data?.image ? 'cursor-pointer' : ''}`}
                        onClick={() => openImage(data?.image)}
                      />
                    </Tooltip>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Permissions Section */}
          <div className="bg-white p-5 rounded-[12px] shadow-[0px_3px_14px_-8px_#888888] border">

            <div className='mb-5'>
              <div className='flex gap-2'>
                <FaListCheck className="text-[#CC9900] text-xl relative top-[1px]" />
                <h4 className='text-[#2D2D2D] font-semibold'>Permissions</h4>
              </div>
              <p className='text-sm text-[#717182]'></p>
            </div>
            <div className="table-design relative table-responsive overflow-x-auto">
              <table class="table w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                <thead class="table_head roleTable">
                  <tr class="">
                    <th
                      scope="col"
                      class="bg-[#CC9900] text-white px-2 py-3"
                    > Module</th>


                    <th
                      scope="col"
                      class="bg-[#CC9900] text-white px-2 py-3"
                    >

                      Read

                    </th>
                    <th
                      scope="col"
                      class="bg-[#CC9900] text-white px-2 py-3"
                    >

                      Add/Edit

                    </th>
                    <th
                      scope="col"
                      class="bg-[#CC9900] text-white px-2 py-3"
                    >

                      Delete

                    </th>

                  </tr>
                </thead>
                <tbody className="roleTable">

                  <>
                    {data?.permissions.map((permission, index) => (<tr>
                      <td className="px-2 py-4 whitespace-nowrap">
                        {permission.module}
                      </td>
                      <td className="px-2 py-4 whitespace-nowrap">
                        {permission?.hide?.includes('read') ? null : (
                          <input
                            type="checkbox"
                            className="h-4 w-4 green_check cursor-pointer shrink-0 rounded-[4px] !border !border-[#3C3E49A3] !text-white"
                            checked={permission.read}
                            disabled
                          />
                        )}
                      </td>


                      <td className="px-2 py-4 whitespace-nowrap">
                        {permission?.hide?.includes('edit') ? null : (
                          <div className="checkList">
                            <label className="mb-0">
                              <input
                                type="checkbox"
                                className="h-4 w-4 green_check cursor-pointer shrink-0 rounded-[4px] !border !border-[#3C3E49A3] !text-white"
                                checked={permission.edit}
                                disabled
                              />
                            </label>
                          </div>
                        )}
                      </td>
                      <td className="px-2 py-4 whitespace-nowrap">
                        {permission?.hide?.includes('delete') ? null : (
                          <div className="checkList">
                            <label className="mb-0">
                              <input
                                type="checkbox"
                                className="h-4 w-4 green_check cursor-pointer shrink-0 rounded-[4px] !border !border-[#3C3E49A3] !text-white"
                                checked={permission.delete}
                                disabled
                              />
                            </label>
                          </div>
                        )}
                      </td>

                    </tr>))}
                  </>

                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default ViewStaff;
